import { useRef, useState, useEffect } from "react";
import FormCreator from "../../../../../components/Forms/FormCreator";
import Accordion from "../../../../../components/Accordion/Accordion";
import { useParams } from "react-router-dom";
import { getFieldParameters } from "../../../../ViewSGBSApplicationFormFeature/utils/setFieldParameter";
import { decryptAESID } from "../../../../../utils/Encryption";
import { setAllDropDownField } from "./utils/dropdownUtils";
import { setmainContactFields } from "./utils/dropdownUtils";
import { CompanyInformationData } from "./data/CompanyInformationData";
import { useLazyGetServiceCompanyInformationDetailsByIdQuery } from "../../../../../app/services/selfEvalutionReviewService/selfEvalutionReviewServiceApi";
import { useLazyGetDropDownsForProductsAndServicesQuery, useCheckServiceForZCPServiceMutation, useLazyGetMainContactPersonDropdownByCorporateMemberIdQuery } from "../../../../../app/services/productAndService/productAndServiceApi";



const CompanyInformation = () => {
  const { id } = useParams();
  const editID = id ? decryptAESID(id, false) : 0;
  const formRefs = useRef();
  const isInitialZCPCheckRef = useRef(true);
  const [formData, setFormData] = useState(CompanyInformationData);
  const [serviceCategory, setServiceCategory] = useState(0)
  const [getServiceCompanyInformationDetailsById, { data: getServiceCompanyInformationData, isLoading: getServiceCompanyInformationLoading, isFetching: getServiceCompanyInformationFetching, }] = useLazyGetServiceCompanyInformationDetailsByIdQuery()
  const [productsAndServicesDropdown, { data: productsAndServicesDropDownsData, isLoading: productsAndServicesDropDownsLoading, },] = useLazyGetDropDownsForProductsAndServicesQuery();
  const [checkServiceForZCPService, { isSuccess: checkServiceForZCPServiceIsSuccess, isLoading: checkServiceForZCPServiceIsLoading, data: checkServiceForZCPServiceData, },] = useCheckServiceForZCPServiceMutation();
  const [mainContactPersonDropdown, { data: mainContactPersonDropdownData, isLoading: mainContactPersonDropdownLoading, },] = useLazyGetMainContactPersonDropdownByCorporateMemberIdQuery();

  useEffect(() => {
    if (checkServiceForZCPServiceData && !checkServiceForZCPServiceIsLoading) {
      const canOfferZCP = !!checkServiceForZCPServiceData?.isZCP;

      setFormData(prev => {
        const isInitialLoad = isInitialZCPCheckRef.current;
        const nextAreYouZCP = isInitialLoad ? prev.initialState.areYouZCP : (canOfferZCP ? prev.initialState.areYouZCP : "no");
        const isZCPYes = canOfferZCP && nextAreYouZCP === "yes";

        let updatedFormFields = toggleFieldVisibility(
          prev.formFields, "areYouZCP", canOfferZCP, "col-lg-12 col-12 mb-4 mt-2 x-position"
        );
        updatedFormFields = toggleFieldVisibility(
          updatedFormFields, "zcpCategories", isZCPYes, "col-lg-6 col-md-6 col-sm-12 mb-3"
        );

        return {
          ...prev,
          formFields: updatedFormFields,
          initialState: {
            ...prev.initialState,
            serviceCategory: serviceCategory,
            areYouZCP: nextAreYouZCP,
          },
        };
      });

      isInitialZCPCheckRef.current = false;
    }
  }, [checkServiceForZCPServiceData, checkServiceForZCPServiceIsLoading]);



  useEffect(() => {
    productsAndServicesDropdown()
    if (editID > 0) {
      getServiceCompanyInformationDetailsById(editID);
    }
  }, [editID])

  useEffect(() => {
    if (getServiceCompanyInformationData && !getServiceCompanyInformationLoading) {
      if (getServiceCompanyInformationData?.sgbsServiceCategoryId > 0) {
        checkServiceForZCPService({ id: getServiceCompanyInformationData?.sgbsServiceCategoryId });
      }
      mainContactPersonDropdown(getServiceCompanyInformationData.sgbcCorporateMemberId);
      setServiceCategory(getServiceCompanyInformationData?.sgbsServiceCategoryId);
      debugger;

      const fieldValues = getFieldParameters(getServiceCompanyInformationData);
      setFormData(prev => ({
        ...prev,
        initialState: { ...prev.initialState, ...fieldValues },
      }));
    }
  }, [getServiceCompanyInformationData, getServiceCompanyInformationLoading]);


  useEffect(() => {
    if (!mainContactPersonDropdownLoading && mainContactPersonDropdownData) {
      setmainContactFields(mainContactPersonDropdownData, setFormData);
    }
  }, [mainContactPersonDropdownLoading, mainContactPersonDropdownData]);

  useEffect(() => {
    if (productsAndServicesDropDownsData && !productsAndServicesDropDownsLoading) {
      setAllDropDownField(productsAndServicesDropDownsData);
    }
  }, [productsAndServicesDropDownsData, productsAndServicesDropDownsLoading])

  const toggleFieldVisibility = (formFields, fieldId, show, baseCss) => {
    return formFields.map(field => {
      if (field.id === fieldId) {
        return {
          ...field,
          style: { ...field.style, containerCss: show ? baseCss : `${baseCss} d-none` },
          validation: show ? [{ type: "require" }] : [],
        };
      }
      return field;
    });
  };

  return (

    <Accordion
      title="Company Information"
      className="mb-4"
      button={false}
      accordion={true}
    >
      <div className="row">
        <FormCreator
          ref={formRefs}
          {...formData}
        />
      </div>
    </Accordion>
  );
}

export default CompanyInformation;
